import React, { useState } from 'react';
import emailjs from 'emailjs-com';

function Price() {
  const [isOpen, setIsOpen] = useState(false); // State to manage modal visibility
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // EmailJS submission
    emailjs
      .send(
        'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
        formData,
        'YOUR_USER_ID' // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          console.log('Email sent successfully:', result.text);
          closeModal();
        },
        (error) => {
          console.log('Email sending error:', error.text);
        }
      );
  };

  return (
    <div>
      {/* Pricing section */}
      <div className="sec-box price section-padding" id="price">
        <div className="sec-head mb-80 wow fadeInUp">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <h6 className="sub-title opacity-7 mb-15">Best Pricing</h6>
              <h3>
                <span className="main-color">Flexible</span> Pricing Plan
              </h3>
            </div>
          </div>
        </div>
        <div className="row md-marg">
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".2s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Basic</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$65</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, WordPress, Laravel/PHP
                    </span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                <a
                        href="#0"
                        className="butn butn-md butn-bord radius-5 text-u full-width"
                        onClick={openModal}
                      >
                        <span>Get Started</span>
                      </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div className="item full-width md-mb50 wow fadeIn" data-wow-delay=".6s">
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Premium</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$105</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, Angular, Vue, WordPress, Laravel/PHP
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Your project alway will be a priority</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Support 6 months</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                <a
                        href="#0"
                        className="butn butn-md butn-bord radius-5 text-u full-width"
                        onClick={openModal}
                      >
                        <span>Get Started</span>
                      </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".4s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Popular</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">$85</h2>
                <p className="ml-20 fz-20">/ hour</p>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Need your wireframe</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Design with Figma, Framer</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Implement with Webflow, React, WordPress, Laravel/PHP
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Support 6 months</span>
                  </li>

                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                <a
                        href="#0"
                        className="butn butn-md butn-bord radius-5 text-u full-width"
                        onClick={openModal}
                      >
                        <span>Get Started</span>
                      </a>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
      </div>

      {/* Modal for form submission */}
      {isOpen && (
        <div className="modal">
          <div className="modal-content">
          <div className='modal-header'>
            <span className="close" onClick={closeModal}>&times;</span>
            <h2>Get Started</h2>
            </div>
            <div className="modal-content-main contact">
            <form onSubmit={handleSubmit}>
            <div className="controls row">
            <div className="col-lg-6">
              <div className="form-group  mb-30">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder=""
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                 <label htmlFor="name"> Name</label>
              </div>
              </div>
              <div className="col-lg-6">
              <div className="form-group  mb-30">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder=""
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="email"> Email</label>
              </div>
              </div>
              <div className="col-lg-12">
              <div className="form-group  mb-30">
                <textarea
                  id="message"
                  name="message"
                  placeholder=""
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <label htmlFor="message"> Message</label>
              </div>
              </div>
              </div>
              <button type="submit"> <span className="text">Submit</span></button>
            </form>
            </div>
          </div>
        </div>
      )}
      {/* Modal Styles */}
      <style jsx>{`
             .modal {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.7);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
              }
              .modal .modal-content {
              background: #232323;
              padding: 0;
              border-radius: 10px;
              width: 80%;
              max-width: fit-content;
              text-align: left;
              position: relative;
              height: auto!important;
              border: 1px solid #ffffff;
              overflow: hidden;
              }
              .modal-content ul li {
              list-style: disc;
              }
              .modal-content h2 {
              margin-bottom: 0;
              padding-right: 40px;
              }
              .modal-content h5 {
              margin:20px auto;
              }
              .modal-content img {
              max-width: -webkit-fill-available;
              margin: 25px;
              }
              .modal-header {
              display: flex;
              flex-shrink: 0;
              align-items: center;
              justify-content: space-between;
              padding: 20px;
              border-bottom: 1px solid #dee2e6;
              border-top-left-radius: calc(.3rem - 1px);
              border-top-right-radius: calc(.3rem - 1px);
              margin-bottom: 15px;
              position: sticky;
              top: 0;
              background: #232323;
              }
.modal-content-main{
padding:20px;
overflow-y: auto;}
              body:has(.modal-content){
              overflow-y: hidden;
              }
.close {
     position: absolute;
              top: 10px;
              right: 10px;
              font-size: 34px;
              cursor: pointer;
              width: 34px;
}


      `}</style>
    </div>
  );
}

export default Price;
